import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "radio-group-container w-full mt-3"
}
const _hoisted_2 = { class: "input-label mb-3 lg:mb-8" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-error" }, "*", -1)
const _hoisted_4 = { class: "grid md:grid-cols-2 gap-2 lg:gap-8 w-full" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "relative flex items-center w-full" }
const _hoisted_7 = ["value", "checked"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "checkmark" }, null, -1)
const _hoisted_9 = { class: "ml-6" }
const _hoisted_10 = {
  key: 0,
  class: "bg-secondary/10 border-none py-0 w-full max-w-[147px] font-medium leading-6 border-2 rounded-[32px] flex items-center justify-center absolute right-0 -top-6"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-center text-secondary text-[11px] font-semibold leading-6" }, " Najczęściej wybierane ", -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = {
  key: 0,
  class: "ml-auto"
}
const _hoisted_16 = { class: "bg-secondary/10 border-none py-3 px-6 w-full max-w-[187px] font-medium leading-6 border-2 rounded-[32px] flex items-center justify-center" }
const _hoisted_17 = { class: "flex items-center justify-center text-secondary text-[14px] font-semibold leading-6" }


import { formatPrice } from '../../../helpers/formatPrice';


export default {
  __name: 'VariationsField',
  props: {
    selectedVariation: {
        type: Number,
        required: true,
    },
    variations: {
        type: Array,
        required: true,
    },
    selectVariation: {
        type: Function,
        required: false,
    },
    name: {
        type: String,
        required: false,
    },
    price: {
        type: String,
        required: true,
    },
},
  setup(__props) {

const props = __props;



function calculatePriceDifferences(variants) {
    let minPrice = null;

    if (!variants) return null;

    variants.forEach((variant) => {
        let price = variant.display_price;
        if (minPrice === null || price < minPrice) {
            minPrice = price;
        }
    });

    variants.forEach((variant) => {
        let price = variant.display_price;
        variant.price_difference = price - minPrice;
    });

    return variants;
}

return (_ctx, _cache) => {
  return (__props.variations.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, [
          _createTextVNode(_toDisplayString(__props.name || 'Czas realizacji') + " ", 1),
          _hoisted_3
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(calculatePriceDifferences(__props.variations), (variation) => {
            return (_openBlock(), _createElementBlock("label", {
              key: variation.variation_id,
              onClick: $event => (__props.selectVariation(variation.variation_id)),
              class: _normalizeClass(["radio-button form-radio-button px-6 py-8 md:px-[32px] md:py-[48px] lg:p-[48px] rounded-3xl border-[1px] border-greyScale100", {
                    'bg-white shadow-feature': __props.selectedVariation === variation.variation_id,
                }])
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("input", {
                  value: variation.variation_id,
                  type: "radio",
                  checked: __props.selectedVariation === variation.variation_id
                }, null, 8, _hoisted_7),
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, [
                  (variation.price_difference > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
                    : _createCommentVNode("", true),
                  _createElementVNode("p", {
                    class: "h4 mb-1",
                    innerHTML: Object.values(variation.attributes).join(', ')
                  }, null, 8, _hoisted_13),
                  _createElementVNode("p", {
                    innerHTML: variation.variation_description
                  }, null, 8, _hoisted_14)
                ]),
                (variation.price_difference > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, " + " + _toDisplayString(_unref(formatPrice)(variation.price_difference)), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 10, _hoisted_5))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

}